"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsPlugin = void 0;
const mount_1 = require("../utils/mount");
const fragment_1 = __importDefault(require("../components/fragment"));
exports.FragmentsPlugin = {
    async install(Vue, options) {
        if ((options === null || options === void 0 ? void 0 : options.mountFunction) && (options === null || options === void 0 ? void 0 : options.initializationData)) {
            Vue.mixin({
                data() {
                    if (this.$root === this) {
                        return {
                            mountParcel: options.mountFunction,
                            initializationData: options.initializationData
                        };
                    }
                    return {};
                }
            });
        }
        Vue.mixin({
            created() {
                if (this.$root === this) {
                    mount_1.MountUtils.initialize(this);
                }
            }
        });
        Vue.component('fragment', fragment_1.default);
    }
};
